import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-275px py-3",
  "data-kt-menu": "true"
}
const _hoisted_2 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content text-muted pb-2 fs-7 text-uppercase" }, " Dispute Response Actions ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-1" }, null, -1)
const _hoisted_5 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_6 = {
  key: 0,
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Find Transaction", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-success btn disabled",
  ref: "findTransactionBtn"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Transaction Found", -1)
const _hoisted_12 = {
  key: 2,
  class: "menu-sub menu-sub-dropdown w-175px py-4"
}
const _hoisted_13 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_14 = {
  ref: "findTransactionBtn",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted"
}
const _hoisted_15 = { class: "menu-icon" }
const _hoisted_16 = { class: "svg-icon svg-icon-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "API Sync", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_19 = { class: "menu-sub menu-sub-dropdown w-300px py-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "menu-icon" }
const _hoisted_22 = { class: "svg-icon svg-icon-2" }
const _hoisted_23 = { class: "menu-title" }
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = {
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_search_api"
}
const _hoisted_26 = { class: "menu-icon" }
const _hoisted_27 = { class: "svg-icon svg-icon-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "API Search", -1)
const _hoisted_29 = { class: "menu-item px-3" }
const _hoisted_30 = { class: "menu-icon" }
const _hoisted_31 = { class: "svg-icon svg-icon-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Form Entry", -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item\"><div class=\"menu-content text-gray-800 pb-1 fs-8 fw-bolder pt-5 text-uppercase\"> Auto Populate: </div></div><div class=\"menu-item my-1\"><div class=\"menu-link-disabled py-3 form-check form-switch form-switch-sm form-check-custom text-muted form-check-solid px-3\"><input class=\"form-check-input text-muted\" type=\"checkbox\" disabled name=\"notifications\"><label class=\"form-check-label\"> Enabled </label></div></div>", 2)
const _hoisted_35 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Create Response", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-success btn disabled"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Response Created", -1)
const _hoisted_41 = {
  key: 2,
  class: "menu-sub menu-sub-dropdown w-250px py-4"
}
const _hoisted_42 = { class: "menu-item px-3" }
const _hoisted_43 = { class: "menu-icon" }
const _hoisted_44 = { class: "svg-icon svg-icon-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Create Evidence", -1)
const _hoisted_46 = {
  key: 1,
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-success btn disabled"
}
const _hoisted_47 = { class: "menu-icon" }
const _hoisted_48 = { class: "svg-icon svg-icon-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Evidence Created", -1)
const _hoisted_50 = { class: "menu-item px-3" }
const _hoisted_51 = { class: "menu-icon" }
const _hoisted_52 = { class: "svg-icon svg-icon-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Edit Response", -1)
const _hoisted_54 = { class: "menu-item px-3" }
const _hoisted_55 = { class: "menu-icon" }
const _hoisted_56 = { class: "svg-icon svg-icon-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Generate QR", -1)
const _hoisted_58 = { class: "menu-item px-3" }
const _hoisted_59 = { class: "menu-icon" }
const _hoisted_60 = { class: "svg-icon svg-icon-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Reset Details", -1)
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item\"><div class=\"menu-content text-muted pb-2 fs-7 pt-5 text-uppercase\"> Auto Respond: </div></div><div class=\"menu-item px-3 my-1\"><div disabled class=\"menu-link-disabled py-3 form-check form-switch form-switch-sm form-check-custom text-muted form-check-solid px-3\"><input class=\"form-check-input text-muted\" type=\"checkbox\" name=\"notifications\"><label class=\"form-check-label\"> Enabled </label></div></div>", 2)
const _hoisted_64 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Send Response", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = {
  key: 1,
  class: "menu-link px-3 disabled svg-icon svg-icon-1 svg-icon-success btn disabled"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Response Sent", -1)
const _hoisted_70 = {
  key: 2,
  class: "menu-sub menu-sub-dropdown w-250px py-4"
}
const _hoisted_71 = { class: "menu-item px-3" }
const _hoisted_72 = { class: "menu-icon" }
const _hoisted_73 = { class: "svg-icon svg-icon-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Dynamic PDF", -1)
const _hoisted_75 = { class: "menu-item px-3" }
const _hoisted_76 = { class: "menu-icon" }
const _hoisted_77 = { class: "svg-icon svg-icon-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "QR Code", -1)
const _hoisted_79 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left, center, top"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Update CRM", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = {
  key: 0,
  class: "menu-sub menu-sub-dropdown w-225px py-4"
}
const _hoisted_84 = { class: "menu-item px-3" }
const _hoisted_85 = {
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
  "data-bs-toggle": "tooltip",
  title: "Coming soon"
}
const _hoisted_86 = { class: "menu-icon" }
const _hoisted_87 = { class: "svg-icon svg-icon-1" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Cancel Purchase", -1)
const _hoisted_89 = { class: "menu-item px-3" }
const _hoisted_90 = {
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
  "data-bs-toggle": "tooltip",
  title: "Coming soon"
}
const _hoisted_91 = { class: "menu-icon" }
const _hoisted_92 = { class: "svg-icon svg-icon-1" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Blacklist Customer", -1)
const _hoisted_94 = { class: "menu-item px-3" }
const _hoisted_95 = {
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
  "data-bs-toggle": "tooltip",
  title: "Coming soon"
}
const _hoisted_96 = { class: "menu-icon" }
const _hoisted_97 = { class: "svg-icon svg-icon-1" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Add Note", -1)
const _hoisted_99 = { class: "menu-item px-3" }
const _hoisted_100 = {
  href: "#",
  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
  "data-bs-toggle": "tooltip",
  title: "Coming soon"
}
const _hoisted_101 = { class: "menu-icon" }
const _hoisted_102 = { class: "svg-icon svg-icon-1" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Update Record", -1)
const _hoisted_104 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item\"><div class=\"menu-content text-muted pb-2 fs-7 pt-5 text-uppercase\"> Auto Update: </div></div><div class=\"menu-item px-3 my-1\"><div class=\"menu-link-disabled py-3 form-check form-switch form-switch-sm form-check-custom text-muted form-check-solid px-3\"><input class=\"form-check-input text-muted\" type=\"checkbox\" name=\"notifications\"><label class=\"form-check-label\"> Enabled </label></div></div>", 2)
const _hoisted_106 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item\"><div class=\"menu-content text-gray-750 pb-1 fs-8 fw-bolder text-uppercase\"> Auto Response Builder: </div></div><div class=\"menu-item my-1\"><div class=\"menu-link-disabled py-3 form-check form-switch form-switch-sm form-check-custom text-muted form-check-solid px-3\"><input class=\"form-check-input text-muted\" disabled type=\"checkbox\" name=\"notifications\"><label class=\"form-check-label\"> Enabled </label></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.incoming.transaction_found === '0')
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, _hoisted_9))
          : (_openBlock(), _createElementBlock("a", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_inline_svg, {
                class: "svg-icon svg-icon-1",
                src: "/media/icons/duotune/general/gen037.svg"
              })
            ], 512)),
        (_ctx.incoming.transaction_found === '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_17,
                  _hoisted_18
                ], 512),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiSyncItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "menu-item px-3 w-auto",
                      key: index
                    }, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (_ctx.findTransaction(item)), ["prevent"]),
                        class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted"
                      }, [
                        _createElementVNode("span", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getConnName(item.connection_id)) + " " + _toDisplayString(item.alias_name), 1)
                      ], 8, _hoisted_20)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_28
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("a", {
                  href: "#",
                  class: "menu-link px-3",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFormEntry && _ctx.onFormEntry(...args)), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_32
                ])
              ]),
              _hoisted_33
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_35, [
        (_ctx.incoming.sent_date === '0000-00-00 00:00:00')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              class: _normalizeClass(["menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn", _ctx.incoming.transaction_found === '0' ? 'disabled' : ''])
            }, _hoisted_38, 2))
          : (_openBlock(), _createElementBlock("a", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_inline_svg, {
                class: "svg-icon svg-icon-1",
                src: "/media/icons/duotune/general/gen037.svg"
              })
            ])),
        (
            _ctx.incoming.transaction_found !== '0' &&
            _ctx.incoming.sent_date === '0000-00-00 00:00:00'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                (_ctx.incoming.dispute_url === '')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCreateResponse && _ctx.onCreateResponse(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                        ])
                      ]),
                      _hoisted_45
                    ]))
                  : (_openBlock(), _createElementBlock("a", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                        ])
                      ]),
                      _hoisted_49,
                      _createVNode(_component_inline_svg, {
                        class: "svg-icon svg-icon-1",
                        src: "/media/icons/duotune/general/gen037.svg"
                      })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("a", {
                  class: _normalizeClass(["menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn", _ctx.incoming.dispute_url === '' ? 'disabled' : '']),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOpenResponseDrawer && _ctx.onOpenResponseDrawer(...args)), ["prevent"])),
                  ref: "openResponseDrawerBtn"
                }, [
                  _createElementVNode("span", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_53
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("a", {
                  class: _normalizeClass(["menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn", _ctx.incoming.dispute_url === '' ? 'disabled' : '']),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onGenerateQR && _ctx.onGenerateQR(...args)), ["prevent"])),
                  ref: "generateQRBtn",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#modal_qr_view"
                }, [
                  _createElementVNode("span", _hoisted_55, [
                    _createElementVNode("span", _hoisted_56, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_57
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("a", {
                  href: "#",
                  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
                  "data-bs-toggle": "tooltip",
                  title: "Reset",
                  ref: "resetBtn",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onReset()), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_59, [
                    _createElementVNode("span", _hoisted_60, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_61
                ], 512)
              ]),
              _hoisted_62
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_64, [
        (_ctx.incoming.sent_date === '0000-00-00 00:00:00')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(["menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn", 
            _ctx.incoming.dispute_url === '' || _ctx.incoming.transaction_found === '0'
              ? 'disabled'
              : ''
          ])
            }, _hoisted_67, 2))
          : (_openBlock(), _createElementBlock("a", _hoisted_68, [
              _hoisted_69,
              _createVNode(_component_inline_svg, {
                class: "svg-icon svg-icon-3",
                src: "/media/icons/duotune/general/gen037.svg"
              })
            ])),
        (_ctx.incoming.sent_date === '0000-00-00 00:00:00')
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("a", {
                  href: "#",
                  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
                  ref: "sendResponseBtn",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendResponse && _ctx.sendResponse(...args)), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_72, [
                    _createElementVNode("span", _hoisted_73, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_74
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("a", {
                  href: "#",
                  class: "menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendResponse && _ctx.sendResponse(...args)), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_76, [
                    _createElementVNode("span", _hoisted_77, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_78
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("a", {
          href: "#",
          class: _normalizeClass(["menu-link px-3 svg-icon svg-icon-1 svg-icon-muted btn", 
            _ctx.incoming.dispute_url === '' ||
            _ctx.incoming.transaction_found === '0' ||
            _ctx.incoming.sent_date === '0000-00-00 00:00:00'
              ? 'disabled'
              : ''
          ])
        }, _hoisted_82, 2),
        (
            _ctx.incoming.dispute_url !== '' &&
            _ctx.incoming.transaction_found !== '0' &&
            _ctx.incoming.sent_date !== '0000-00-00 00:00:00'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("a", _hoisted_85, [
                  _createElementVNode("span", _hoisted_86, [
                    _createElementVNode("span", _hoisted_87, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_88
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("a", _hoisted_90, [
                  _createElementVNode("span", _hoisted_91, [
                    _createElementVNode("span", _hoisted_92, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_93
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("a", _hoisted_95, [
                  _createElementVNode("span", _hoisted_96, [
                    _createElementVNode("span", _hoisted_97, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_98
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("a", _hoisted_100, [
                  _createElementVNode("span", _hoisted_101, [
                    _createElementVNode("span", _hoisted_102, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                    ])
                  ]),
                  _hoisted_103
                ])
              ]),
              _hoisted_104
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_106
    ])
  ]))
}